<template>
  <div class="sidebar" :class="'sidebar-'+theme">
    <div class="sidebar-wrapper" ref="sidebarScrollArea">

      <div class="logo">
        <a href="https://top-trader.org" target="blank" class="text-center logo-mini">
          <img width="40" :src="theme === 'black' ? 'static/img/everinvestor/icon-w.png' : 'static/img/everinvestor/icon-b.png'" alt="logoSymbol">
        </a>
        <a href class="simple-text logo-normal text-warning pl-5">
          <img width="100" :src="theme === 'black' ? 'static/img/everinvestor/logo-w.png' : 'static/img/everinvestor/logo-b.png'" alt="logoText">
        </a>
      </div>

      <slot></slot>

      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>

    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "TopTrader"
    },
    // backgroundColor: {
    //   type: String,
    //   default: "toptrader",
    //   validator: value => {
    //     let acceptedValues = [
    //       "",
    //       "blue",
    //       "azure",
    //       "toptrader",
    //       "green",
    //       "orange",
    //       "red",
    //       "purple",
    //       "black",
    //       "dark"
    //     ];
    //     return acceptedValues.indexOf(value) !== -1;
    //   }
    // },
    // backgroundImage: {
    //   type: String,
    //   default: ""
    // },
    activeColor: {
      type: String,
      default: "success",
      validator: value => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logoSymbol: {
      type: String,
      default: "static/img/logoSymbol.png"
    },
    logoText: {
      type: String,
      default: "static/img/logoText.png"
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  methods: {
    async initScrollBarAsync() {
      await import("perfect-scrollbar/dist/css/perfect-scrollbar.css");
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    }
  },
  mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  methods: {
    async initScrollBarAsync () {
      await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
      const PerfectScroll = await import('perfect-scrollbar')
      PerfectScroll.initialize(this.$refs.sidebarScrollArea)
    }
  },
  mounted () {
    this.initScrollBarAsync()
  },
  beforeDestroy () {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  }
};
</script>
<style>
.sidebar-black {
  background-color: #121315 !important;
}

.sidebar-light {
  background-color: #d8d8d8 !important;
}

@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarPlugin/SideBar.vue